import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import notificationService from './notificationService';
import { getNotificationRoute } from './nativeNotificationService';

let currentDeviceToken = null;

const isNative = () => Capacitor.isNativePlatform();

const normalizePushData = (notification = {}) => {
  const data = notification.data || {};
  return {
    notificationId: data.notificationId || data.notification_id || notification.id || null,
    route: getNotificationRoute({
      route: data.route,
      link: data.link,
      category: data.category
    }),
    category: data.category || ''
  };
};

export const registerNativePushNotifications = async ({
  authToken,
  onReceived,
  onAction
} = {}) => {
  if (!isNative() || !authToken) return { remove: async () => {} };

  const handles = [];

  handles.push(await PushNotifications.addListener('registration', async ({ value }) => {
    currentDeviceToken = value;
    try {
      await notificationService.registerPushDevice(value, Capacitor.getPlatform(), authToken);
    } catch (error) {
      console.warn('Push token could not be registered with the server:', error);
    }
  }));

  handles.push(await PushNotifications.addListener('registrationError', ({ error }) => {
    console.warn('Native push registration failed:', error);
  }));

  handles.push(await PushNotifications.addListener('pushNotificationReceived', (notification) => {
    onReceived?.({ notification, ...normalizePushData(notification) });
  }));

  handles.push(await PushNotifications.addListener('pushNotificationActionPerformed', (event) => {
    onAction?.({ notification: event.notification, ...normalizePushData(event.notification) });
  }));

  let permission = await PushNotifications.checkPermissions();
  if (['prompt', 'prompt-with-rationale'].includes(permission.receive)) {
    permission = await PushNotifications.requestPermissions();
  }

  if (permission.receive === 'granted') {
    await PushNotifications.register();
  }

  return {
    remove: async () => {
      await Promise.all(handles.map((handle) => handle.remove()));
    }
  };
};

export const unregisterCurrentPushDevice = async (authToken) => {
  if (!isNative() || !currentDeviceToken || !authToken) return;

  const tokenToRemove = currentDeviceToken;
  currentDeviceToken = null;

  try {
    await notificationService.unregisterPushDevice(tokenToRemove, authToken);
  } finally {
    await PushNotifications.unregister().catch(() => {});
  }
};

